import React from 'react';
import { Link } from 'fw/components/formatter/Formatter';

class TimeSummaryValueFormatter extends React.Component {
	handleClick = (e) => {
		e.stopPropagation();
		return false;
	}

	shouldComponentUpdate(nextProps) {
		return nextProps.value !== this.props.value;
	}

	_formatDate(dateString) {
		if (!dateString) return '';
		const date = new Date(dateString);
		return date.toISOString().split('T')[0];
	}

	_getLinkValue() {
		const row = this.props.dependentValues;
		const displayValue = this.props.value || (row.isCurrency ? "$0.00" : "0");

		let url;

		if (row.linkType === 'approve') {
			const dateFrom = this._formatDate(row.dateFrom);
			const dateTo = this._formatDate(row.dateTo);
			url = `/admin/connectToVOB?approveDateFrom=${dateFrom}&approveDateTo=${dateTo}`;
		} else if (row.linkType === 'expiration') {
			const dateFrom = this._formatDate(row.dateFrom);
			const dateTo = this._formatDate(row.dateTo);
			url = `/admin/connectToVOB?certificationStatusCode=EXP&expirationDateFrom=${dateFrom}&expirationDateTo=${dateTo}`;
		} else {
			const dateFrom = this._formatDate(row.dateFrom);
			const dateTo = this._formatDate(row.dateTo);
			url = '/admin/searchQueue?showAll=true&';

			if (row.linkType === 'prequal') {
				url += `preQualDateFrom=${dateFrom}&preQualDateTo=${dateTo}`;
			} else if (row.linkType === 'submit') {
				url += `submitDateFrom=${dateFrom}&submitDateTo=${dateTo}`;
			} else if (row.linkType === 'create') {
				url += `createDateFrom=${dateFrom}&createDateTo=${dateTo}`;
			}
		}

		return {
			url: url,
			title: displayValue
		};
	}

	render() {
		const row = this.props.dependentValues;
		const centerAlignStyle = { display: "block", textAlign: "center" };
		const displayValue = this.props.value || (row.isCurrency ? "$0.00" : "0");

		if (displayValue === "0" || displayValue === "$0.00") {
			return (
				<span style={centerAlignStyle}>
					{displayValue}
				</span>
			);
		}

		return <Link value={this._getLinkValue()} style={centerAlignStyle}></Link>;
	}
}

export default TimeSummaryValueFormatter;



// WEBPACK FOOTER //
// ./src/areas/shared/components/formatter/TimeSummaryValueFormatter.js